// extracted by mini-css-extract-plugin
export var banner = "_t4-0";
export var settingRow = "_t4-2";
export var titleIcon = "_t4-1";